import { Effect, Schema as S } from "effect";

export const GetTiRequestSchema = S.Struct({
  name: S.String,
  ti: S.Boolean,
  sort: S.optional(S.String),
  page: S.optional(S.Int).pipe(S.withDecodingDefault(Effect.succeed(0))),
  itemsPerPage: S.optional(S.Int).pipe(S.withDecodingDefault(Effect.succeed(1000))),
  noCountLimit: S.optional(S.Union([S.Literal("true"), S.Literal("false")])).pipe(
    S.withDecodingDefault(Effect.succeed("false" as const)),
  ),
});

export type GetTiRequest = S.Schema.Type<typeof GetTiRequestSchema>;
